import React, { useCallback } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { createLocale } from 'locales';

import Typography from 'components-new/typography/typography';
import Button from 'components-new/button/button';
import VideoPreview from 'components/video-preview';

import { STATIC_FILES_URL } from 'constants/signup-flow-constants';

import FreelancerSignUpPageContainer from '../components/freelancer-sign-up-page-container';
import freelancerRoutes from '../freelancer-routes';
import HeaderDialog from '../components/freelancer-sign-up-page-container/header-dialog';

const localize = createLocale('freelancerWelcomePageLocales');
const globalLocalize = createLocale('global');

const Welcome: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams({});
  const videoPreviewImageURLPage1 = `${window.STATIC_URL}assets/signupflow/h1.png`;
  const videoPreviewImageURLPage2 = `${window.STATIC_URL}assets/signupflow/h2.png`;
  const videoURLPage1 = `${STATIC_FILES_URL}videos/signupflow/intro.mp4`;
  const videoURLPage2 = `${STATIC_FILES_URL}videos/signupflow/h1.mp4`;

  const onNextVideoClicked = useCallback(() => {
    setSearchParams({
      shouldShowNextPage: 'true',
    });
  }, [setSearchParams]);

  const onStartRegistrationClicked = useCallback(() => {
    navigate(freelancerRoutes.fillInformation.path);
  }, [navigate]);

  const closeInstructionsDialog = useCallback(() => {
    setSearchParams({
      shouldInstructionsDialog: 'false',
    });
  }, [setSearchParams]);

  const openInstructionsDialog = useCallback(() => {
    setSearchParams({
      shouldInstructionsDialog: 'true',
    });
  }, [setSearchParams]);

  return (
    <FreelancerSignUpPageContainer showHeader headerTitle={localize('title')}>
      {searchParams.get('shouldShowNextPage') !== 'true' && (
        <>
          <Typography
            as="p"
            variant="body-medium"
            className="text-gray500 whitespace-pre-line mb-2"
          >
            {localize('instructions1')}
          </Typography>
          <VideoPreview
            videoPreviewImageURL={videoPreviewImageURLPage1}
            videoURL={videoURLPage1}
          />
          <Button
            label={localize('nextVideo')}
            variant="primary"
            className="w-full justify-center mt-10"
            onClick={onNextVideoClicked}
          />
        </>
      )}
      {searchParams.get('shouldShowNextPage') === 'true' && (
        <>
          <Typography
            as="p"
            variant="body-medium"
            className="text-gray500 whitespace-pre-line"
          >
            {localize('instructions2')}
          </Typography>

          <VideoPreview
            className="my-2"
            videoPreviewImageURL={videoPreviewImageURLPage2}
            videoURL={videoURLPage2}
          />

          <Typography
            as="p"
            variant="body-medium"
            className="mt-4 text-gray500 whitespace-pre-line text-center"
          >
            {localize('preferToReadInstructions')}
            <button
              type="button"
              className="text-body-medium-bold font-bold text-purple whitespace-pre-line cursor-pointer"
              onClick={openInstructionsDialog}
            >
              {globalLocalize('clickHere')}
            </button>
          </Typography>

          <Button
            label={localize('start')}
            variant="primary"
            className="w-full justify-center mt-10"
            onClick={onStartRegistrationClicked}
          />
        </>
      )}
      <HeaderDialog
        onCloseClicked={closeInstructionsDialog}
        isOpen={searchParams.get('shouldInstructionsDialog') === 'true'}
        title={localize('title')}
        buttonProps={{
          label: globalLocalize('goBack'),
          onClick: closeInstructionsDialog,
          variant: 'outlined',
        }}
        className="max-w-[80%] lg:max-w-[60%]"
      >
        <Typography as="p" variant="body-large-bold" className="text-gray700">
          {globalLocalize('instructions')}
        </Typography>
        <Typography
          as="p"
          variant="body-medium"
          className="text-gray600 mt-2 whitespace-pre-wrap"
        >
          {localize('welcomeDialogInstructions')}
        </Typography>
      </HeaderDialog>
    </FreelancerSignUpPageContainer>
  );
};

export default Welcome;
